<template>
    <div class="well" v-if="distribution.permission">
        <i class="fas fa-caret-square-down" @click="expand()" title="Expand elements"></i>
        <a @click="expand()"> {{ distribution.name }} </a>
        <a class="pull-right" :href="objectUrl + distribution.id" target="_blank">
            <i class="fal fa-external-link" title="Open distribution in new tab"></i>
        </a>
        <!--
            v-html is dangerous and should only be used in certain situations
            These definitions are bleached on entry to the database
            TODO: look for a better way to render this information
            e.g. such as - render a smaller definition which only has plain text
         -->
        <p v-html="distribution.definition" />

        <div v-if="isExpanded">
            <distribution-data-element-path :distribution="distribution" />
        </div>
    </div>
    <div class="well" v-else>
        <p><em>You do not have permission to view this distribution</em></p>
    </div>
</template>

<script>
import DistributionDataElementPath from 'src/components/dataset/components/DistributionDataElementPath.vue'

export default {
    name: "DistributionDisplay",
    components: {
        DistributionDataElementPath
    },
    props: {
        // The distribution which is rendered in this component
        distribution: {
            type: Object,
            required: true,
        }
    },
    data: () => ({
        isExpanded: false,
        objectUrl: '/item/'
    }),
    methods: {
        expand: function() {
            this.isExpanded = !this.isExpanded
        }
    }

}
</script>

<style scoped>
a {
    cursor: pointer;
}
</style>
